import XApi from './api';
import XEndpoints from '../core/config/Endpoints';

export class UploadService {
    async upload(file) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.upload(XEndpoints.upload, {
                'Authorization': token,
            }, [file]);
            return response.data ?? [];
        }
        return [];
    }
}